import { Reveal } from "./Reveal";
import { MapPin, Clock, ArrowUpRight } from "lucide-react";

const locations = [
  {
    name: "Needful Things Mall",
    address: "On Route 64 · Hendersonville, NC",
    note: "Our main booth — U.S. classics, Pick-a-Packet booth, souvenir sheets, and covers.",
    hours: "Mall hours",
  },
  {
    name: "eBay Store",
    address: "Online · Ships worldwide",
    note: "U.S. mint sheets, booklets, booklet panes, plate blocks, year sets, and covers.",
    hours: "Open 24/7",
    href: "https://www.ebay.com/str/carolinamountainstamps",
  },
];

export function Locations() {
  return (
    <section id="locations" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6">
        <div className="flex flex-col items-start justify-between gap-8 md:flex-row md:items-end">
          <div className="max-w-xl">
            <Reveal>
              <p className="mb-4 text-xs uppercase tracking-[0.28em] text-accent">
                Where to find us
              </p>
            </Reveal>
            <Reveal delay={1}>
              <h2 className="font-display text-4xl text-primary md:text-5xl">
                Two doors into the same collection.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={2}>
            <p className="max-w-sm text-sm text-muted-foreground">
              Prefer to browse in person? Come see the books and boxes. Prefer
              to shop from home? Our eBay store carries the full mail-order
              catalogue.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-2">
          {locations.map((loc, i) => {
            const Wrapper: React.ElementType = loc.href ? "a" : "div";
            const wrapperProps = loc.href
              ? {
                  href: loc.href,
                  target: "_blank",
                  rel: "noreferrer noopener",
                  "aria-label": `${loc.name} (opens in a new tab)`,
                }
              : {};
            return (
              <Reveal key={loc.name} delay={i}>
                <Wrapper
                  {...wrapperProps}
                  className="group relative flex h-full flex-col border border-border bg-card p-7 shadow-[var(--shadow-stamp)] transition-transform hover:-translate-y-1"
                >
                  <div className="flex items-center justify-between">
                    <MapPin className="h-5 w-5 text-accent" aria-hidden="true" />
                    {loc.href && (
                      <ArrowUpRight className="h-4 w-4 text-muted-foreground transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" aria-hidden="true" />
                    )}
                  </div>
                  <h3 className="mt-6 font-display text-2xl text-primary">
                    {loc.name}
                  </h3>
                  <p className="mt-1 text-sm text-muted-foreground">{loc.address}</p>
                  <p className="mt-5 text-sm text-muted-foreground">{loc.note}</p>
                  <div className="mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-widest text-muted-foreground">
                    <Clock className="h-3.5 w-3.5" aria-hidden="true" />
                    {loc.hours}
                  </div>
                </Wrapper>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}